export default __webpack_public_path__ + "static/6-dd97765ad89a0a008a54f50b222c605b.png";